<template>
  <div class="bg-white rounded-lg shadow">
    <div class="grid grid-cols-5  gap-[1px] bg-gray-300 overflow-hidden rounded-lg">
      <div class="bg-white text-center p-2.5">
        <label for="first_name" class="block text-xs font-medium uppercase text-gray-500 tracking-wide">{{
            __('Status')
          }}</label>
        <p class="text-gray-900 text-sm font-semibold mt-0.5 sm:mt-0">{{ capitalizeFirstLetter(license.status.toLowerCase()) }}</p>
      </div>
      <div class="bg-white text-center p-2.5">
        <label for="first_name" class="block text-xs font-medium uppercase text-gray-500 tracking-wide">{{
            __('Plan')
          }}</label>
        <p class="text-gray-900 text-sm font-semibold mt-0.5 sm:mt-0">{{ __(license.package.name) }}</p>
      </div>
      <div class="bg-white text-center p-2.5">
        <label for="first_name" class="block text-xs font-medium uppercase text-gray-500 tracking-wide">{{
            __('Price')
          }}</label>
        <p class="text-gray-900 text-sm font-semibold mt-0.5 sm:mt-0">{{
            price(license.price)
          }}</p>
      </div>
      <div class="bg-white text-center p-2.5">
        <label for="first_name" class="block text-xs font-medium uppercase text-gray-500 tracking-wide">{{
            __('Period')
          }}</label>
        <p class="text-gray-900 text-sm font-semibold mt-0.5 sm:mt-0">
          {{ __(license.package.billing_cycle === '30 days' ? 'Monthly' : 'Annually') }}</p>
      </div>
      <div class="bg-white text-center p-2.5">
        <label for="first_name" class="block text-xs font-medium uppercase text-gray-500 tracking-wide">{{
            __('Next Billing Date')
          }}</label>
        <p class="text-gray-900 text-sm font-semibold mt-0.5 sm:mt-0">{{
            date(license.expires_at)
          }}</p>
      </div>
    </div>
  </div>

  <div class="bg-white shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <h3 class="text-base font-semibold leading-6 text-gray-900">{{ __('Subscription') }}</h3>
      <div class="mt-2 max-w-xl text-sm text-gray-500">
        <p>{{ __('The subscription can be cancelled at any time and is not bound to any cancellation period. After cancelling, no more payments will be collected for this license, the license is available until expiration.') }}</p>
      </div>
      <div class="mt-5">
        <inertia-link :method="'POST'" :href="route('license.subscription.cancel', {license})" v-if="license.status == 'ACTIVE'">
          <danger-button>{{ __('Cancel Subscription') }}</danger-button>
        </inertia-link>
        <inertia-link :method="'POST'" :href="route('license.subscription.reactivate', {license})" v-if="license.status == 'CANCELLED'">
          <primary-button>{{ __('Reactivate Subscription') }}</primary-button>
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
import DangerButton from "@/Jetstream/DangerButton";
import PrimaryButton from "@/Jetstream/PrimaryButton";
export default {
  name: "Subscription",
  components: {PrimaryButton, DangerButton},
  props: ['license'],
}
</script>